import { Tooltip, TooltipProps } from '@mui/material';

export const StyledTooltip = ({
    title,
    children,
    placement = 'left'
}: {
    title: string;
    children: React.ReactElement;
    placement?: TooltipProps['placement'];
}) => (
    <Tooltip
        title={title}
        placement={placement}
        arrow
        componentsProps={{
            tooltip: {
                sx: {
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#fffff',
                    padding: '4px 8px',
                    bgcolor: '#54595E',
                    letterSpacing: '0.17px'
                }
            },
            arrow: {
                sx: {
                    color: '#54595E',
                    width: '12px'
                }
            }
        }}
    >
        {children}
    </Tooltip>
);
